import { getCustomersRestricted } from 'api/CustomersApi';
import { AccordionBodyItem } from 'component/Accordion';
import { SelectComponent } from 'component/Select';
import { useDispatchWithFallback } from 'hooks/useDispatchWthFallback';
import React, { useEffect, useState } from 'react';
import { useUser } from 'routes/UserContext';
import { UPDATE_DMS_FIELD } from 'reducers/dailyFormActions';
import { axiosWrapper } from 'utils/Helper';

export const DailyTaskCustomer = ({ formData, dispatch: propsDispatch, hasError }) => {
  const dispatch = useDispatchWithFallback(propsDispatch);
  const { user } = useUser();
  const [options, setOptions] = useState([]);
  const value = formData?.info?.dms?.task_customer;

  useEffect(() => {
    axiosWrapper(() => {
      getCustomersRestricted()
        .then((res) => {
          const data = res?.data?.results ?? res?.data ?? [];
          const list = Array.isArray(data) ? data : [];
          setOptions(
            list.map((item) => ({
              value: item.id,
              label: item.name,
            }))
          );
        })
        .catch((err) => console.error(err));
    });
  }, []);

  useEffect(() => {
    if (value != null || !user?.default_customer) return;
    const defaultId = user.default_customer?.id ?? user.default_customer;
    if (defaultId) {
      dispatch({
        type: UPDATE_DMS_FIELD,
        payload: { field: 'task_customer', value: defaultId },
      });
    }
  }, [user?.default_customer, dispatch]);

  const handleSelect = (selected) => {
    dispatch({
      type: UPDATE_DMS_FIELD,
      payload: {
        field: 'task_customer',
        value: selected?.value ?? selected ?? null,
      },
    });
  };

  return (
    <AccordionBodyItem
      accordionSubId={
        <div>
          <span>1.4</span>
          <span className="star">*</span>
        </div>
      }
      titleUA="Замовник задачі"
      titleEN="Task customer"
      className={hasError ? 'error error-text' : ''}
      children={
        <SelectComponent
          isMulti={false}
          value={
            value
              ? {
                  value: options.find((o) => o.value === value)?.value ?? value,
                  label: options.find((o) => o.value === value)?.label ?? '',
                }
              : null
          }
          handleSelect={handleSelect}
          options={options}
          placeholder="Select"
          isSearchable
        />
      }
    />
  );
};

export const DailyTaskCustomerView = ({ taskCustomerId, taskCustomerName }) => (
  <AccordionBodyItem
    accordionSubId={1.4}
    titleUA="Замовник задачі"
    titleEN="Task customer"
    children={taskCustomerName || taskCustomerId || '-'}
  />
);
